import React from "react";
import { Container } from "react-bootstrap";
import "../../Counsellor/Counsellor.css";

const CounsellorFooter = () => {
  return (
    <footer
      className="bg-dark text-white text-center p-3"
      style={{
        bottom: 0,
        left: 0,
        width: "100%",
        zIndex: 10,
      }}
    >
      <Container>
        &copy; {new Date().getFullYear()} Texas School of Mental Health. All
        Rights Reserved.
      </Container>
    </footer>
  );
};

export default CounsellorFooter;
